module.exports = __webpack_public_path__ + "static/img/（环卫车-B激光雷达）.c8ce367.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/type-1/（环卫车-B激光雷达）.png
// module id = jww8
// module chunks = 0